import Layout from "@/components/Layout";
import HubSpotForm from "@/components/HubSpotForm";

// Converted from second-opinion-thoracic-surgeon-india.php by scripts/convert-php-pages.mjs.
export default function PageSecondOpinionThoracicSurgeonIndia() {
  return (
    <Layout route="/second-opinion-thoracic-surgeon-india">
      <>
<style dangerouslySetInnerHTML={{ __html: "\r\n    .accordion li {\r\n    position: relative;\r\n    list-style-type: auto;\r\n    margin-bottom:0px;\r\n}\r\n" }} />
<div className="service-details-area" style={{ background: "#fdefef" }}>
<div className="" style={{ backgroundImage: "url(assets/img/stage-0.webp)", height: "500px", backgroundSize: "cover", backgroundPosition: "left center" }}>
<div className="container" style={{ height: "100%" }}>
<div className=" row" style={{ height: "100%" }}>
<div className="col-md-6">
<div className="d-flex flex-column justify-content-center" style={{ height: "100%", padding: "15px" }}>
<h1 style={{ color: "white", fontWeight: "bold" }}>Get a Free Second Opinion for Chest & Lung Conditions</h1>
<div className="d-flex flex-column flex-md-row">
<button className="btn btn-primary" style={{ margin: "5px", color: "#104bb3", backgroundColor: "white", fontWeight: "bold" }}><a href="/contact">Get Appointment</a></button>
<button className="btn btn-primary" style={{ margin: "5px", backgroundColor: "#104bb3", border: "1px solid white", fontWeight: "bold" }}><a href="/blog" style={{ color: "white" }}>Learn More</a></button>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="container">
<div className="services-details-img">
<h2>Don’t Decide Without Complete Clarity</h2>
<p>Have you or your loved one been diagnosed with a chest or lung condition like lung cancer, mediastinal tumor, or esophageal disease? Before agreeing to any surgery or treatment, it's important to get an expert opinion from a highly experienced thoracic surgeon.</p>
<p>At Chest Surgery India, we offer a completely free second opinion service provided directly by Dr. Parveen Yadav, one of India’s most trusted thoracic surgeons. This service is designed to help you understand your diagnosis better, explore treatment options, and feel confident in your next steps.
</p>
<hr />
<h2>Why a Second Opinion Matters</h2>
<ul>
<li>Confirm your current diagnosis with a senior expert</li>
<li>Explore less invasive or alternative treatment options</li>
<li>Avoid unnecessary surgeries or high-risk procedures</li>
<li>Make informed decisions based on medical evidence</li>
<li>No cost or obligation — 100% free and confidential</li>
</ul>
<p>Many patients feel uncertain or pressured after their first consultation. Our goal is to provide clarity, not confusion.</p>
<hr />
<h2>About Dr. Parveen Yadav</h2>

<p>Dr. Parveen Yadav is a senior thoracic surgeon with over 15 years of experience treating complex chest conditions. He specializes in lung cancer, esophageal disorders, mediastinal tumors, chest wall reconstruction, and VATS (Video-Assisted Thoracoscopic Surgery). Known for his ethical, transparent, and patient-focused approach, Dr. Yadav has helped thousands of patients across India and abroad.</p>
<hr />
<div className="row">
<div className="col-lg-5 p-0">
<h4>Submit Your Case for a Free Second Opinion</h4>
<p>To receive your expert review, please fill out the Second Opinion Request Form on this page. Make sure to upload:</p>
<ul>
<li>Your current diagnosis summary or doctor's note</li>
<li>Test reports (CT scan, PET scan, biopsy, etc.)</li>
<li>Any recommended treatment plan or prescriptions</li>
<li>Specific questions you want Dr. Yadav to address</li>
</ul>
<p>Our medical team will review your case and respond within 24–48 working hours.
</p>
<p><b>Note:</b> All information shared is treated with complete confidentiality. This is a no-obligation service intended only to support your health decisions.
</p>
<h4>Your Health. Your Choice. Our Guidance.</h4>
<p>Take the first step toward clarity. Submit your reports through the form now and receive your free expert opinion within 48 hours.
</p>
</div>
<div className="col-lg-7 p-0">
<div className="drop-item drop-img">
<div className="drop-left">
<h2>Drop your message for any info or question.</h2>

<HubSpotForm />
</div>
</div>
</div>
</div>

</div>
<section className="drop-area pt-100" id="contact-sec">
<div className="container-fluid"></div>
</section>

<div className="container my-4">
<div className="row">
<div className="col-lg-12">
<h2 style={{ textAlign: "center", paddingBottom: "30px" }}>FAQs</h2>
<div className="accordion" id="accordionExample">
<div className="accordion-item">
<h2 className="accordion-header" id="headingOne">
<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    1. What conditions can I get a second opinion for?
                    </button>
</h2>
<div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
<div className="accordion-body">
                    You can request a second opinion for any thoracic condition including:
                    <ul>
<li>Lung cancer</li>
<li>Chest wall tumors</li>
<li>Mediastinal masses</li>
<li>Pleural effusion</li>
<li>Esophageal cancer</li>
<li>Tracheal or airway strictures</li>
<li>Diaphragmatic injury or hernia</li>
</ul>
</div>
</div>
</div>
<div className="accordion-item">
<h2 className="accordion-header" id="headingTwo">
<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    2. Is the second opinion really free?
                    </button>
</h2>
<div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
<div className="accordion-body">
                    Yes. There is absolutely no charge for this service. Our aim is to empower patients with the right guidance at no cost.
                    </div>
</div>
</div>
<div className="accordion-item">
<h2 className="accordion-header" id="headingThree">
<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    3. Who reviews the reports?
                    </button>
</h2>
<div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
<div className="accordion-body">
                   All cases are personally reviewed by Dr. Parveen Yadav, ensuring accurate evaluation and suggestions.
                    </div>
</div>
</div>
<div className="accordion-item">
<h2 className="accordion-header" id="headingFour">
<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                      4. Can I request a second opinion from outside India?
                      </button>
</h2>
<div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
<div className="accordion-body">
                      Yes. We support both Indian and international patients. As long as you provide complete documents in the form, your case will be evaluated.
                    </div>
</div>
<div className="accordion-item">
<h2 className="accordion-header" id="headingFive">
<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                      5. What happens after I receive the second opinion?
                      </button>
</h2>
<div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
<div className="accordion-body">
                       You are free to decide your next step. If you wish to proceed with treatment under Dr. Yadav, we will help you schedule an appointment — but there is no obligation or pressure.
                      </div>
</div>
</div>































































</div>
</div>
</div>
</div>
<div className="row" style={{ paddingTop: "50px" }}>
<h2 style={{ textAlign: "center", paddingBottom: "30px" }}>Videos</h2>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<iframe width="100%" height="208" src="https://www.youtube.com/embed/e7YXXCmJsnM" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>                </div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<iframe width="100%" height="208" src="https://www.youtube.com/embed/PTwWMOweu98" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>                </div>
</div>
</div>
</div>
</div>
      </>
    </Layout>
  );
}
